import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import {NgxWebstorageModule} from 'ngx-webstorage';
import { BlockUIModule } from 'ng-block-ui';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeModule } from './home/home.module';
import { HelpModule } from './help-page/help.module';
import { WaterSystemsModule } from './water-systems/water-systems.module';
import { WaterMapsModule } from './water-maps/water-maps.module'
import { CustomHttpInterceptor } from './custom-http-interceptor'
import { SharedService } from './shared.service'

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HomeModule,
    HelpModule,
    WaterSystemsModule,
    WaterMapsModule,
    NgxWebstorageModule.forRoot(),
    BlockUIModule.forRoot(),
    BrowserModule.withServerTransition({appId: 'nys-water-quality'})
  ],
  providers: [
    SharedService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
